"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 16c-4.411 0-8-3.589-8-8 0-4.412 3.589-8 8-8s8 3.588 8 8c0 4.411-3.589 8-8 8ZM8 .941A7.066 7.066 0 0 0 .941 8 7.067 7.067 0 0 0 8 15.059 7.067 7.067 0 0 0 15.059 8 7.066 7.066 0 0 0 8 .941ZM5.243 7.356a1 1 0 1 0 0-2.001 1 1 0 0 0 0 2Zm6.514-1a1 1 0 1 1-2-.001 1 1 0 0 1 2 0Zm-7.992 6.4a.5.5 0 0 0 .676-.206c.048-.089 1.204-2.193 3.568-2.193s3.5 2.102 3.548 2.191a.5.5 0 0 0 .886-.463c-.057-.112-1.455-2.728-4.434-2.728-2.977 0-4.393 2.614-4.45 2.725a.498.498 0 0 0 .206.674Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0c6.616 0 12 5.383 12 12s-5.384 12-12 12Zm0-22.925C5.976 1.075 1.075 5.976 1.075 12c0 6.025 4.901 10.926 10.925 10.926 6.024 0 10.925-4.901 10.925-10.926 0-6.024-4.901-10.925-10.925-10.925Zm-4.135 9.96a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9.77-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM5.736 18.97a.564.564 0 0 0 .76-.233c.075-.138 1.854-3.39 5.518-3.39 3.663 0 5.415 3.25 5.487 3.387a.563.563 0 0 0 .997-.521c-.084-.162-2.128-3.99-6.484-3.99-4.353 0-6.425 3.825-6.511 3.987a.563.563 0 0 0 .233.76Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16 32C7.178 32 0 24.823 0 16 0 7.178 7.178 0 16 0s16 7.178 16 16c0 8.823-7.178 16-16 16Zm0-30.567C7.968 1.433 1.433 7.968 1.433 16c0 8.033 6.535 14.568 14.567 14.568S30.567 24.033 30.567 16c0-8.032-6.535-14.567-14.567-14.567Zm-5.514 13.28a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm13.028-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM7.648 25.295a.753.753 0 0 0 1.014-.31c.099-.185 2.471-4.52 7.357-4.52 4.883 0 7.219 4.332 7.316 4.516a.75.75 0 0 0 1.33-.695c-.113-.217-2.839-5.321-8.646-5.321-5.804 0-8.567 5.1-8.682 5.317a.75.75 0 0 0 .311 1.013Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24 48C10.766 48 0 37.233 0 24 0 10.766 10.766 0 24 0s24 10.766 24 24c0 13.233-10.766 24-24 24Zm0-46.196C11.761 1.804 1.805 11.761 1.805 24S11.762 46.196 24 46.196c12.239 0 22.196-9.957 22.196-22.196 0-12.24-9.957-22.195-22.196-22.195Zm-8.27 20.264a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm19.54-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-.1 18.314a.937.937 0 1 0 1.66-.867c-.166-.322-4.204-7.881-12.802-7.881-8.593 0-12.687 7.554-12.857 7.876a.938.938 0 0 0 1.657.878c.037-.07 3.754-6.88 11.2-6.88 7.442 0 10.993 6.592 11.142 6.875Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32 64C14.355 64 0 49.644 0 32 0 14.355 14.355 0 32 0s32 14.355 32 32c0 17.644-14.355 32-32 32Zm0-61.594C15.682 2.406 2.406 15.681 2.406 32c0 16.318 13.276 29.594 29.594 29.594S61.594 48.318 61.594 32C61.594 15.681 48.318 2.406 32 2.406ZM20.973 29.424a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm26.054-4a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.134 24.42a1.25 1.25 0 1 0 2.215-1.158c-.223-.429-5.606-10.508-17.07-10.508-11.458 0-16.916 10.072-17.143 10.501a1.25 1.25 0 0 0 2.209 1.171c.049-.092 5.006-9.172 14.934-9.172 9.922 0 14.657 8.79 14.855 9.165Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconFeedbackSad = function IconFeedbackSad(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Feedback Sad' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "FeedbackSad"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconFeedbackSad.sizes = [16, 24, 32, 48, 64];
IconFeedbackSad.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconFeedbackSad;
exports.default = _default;